const resolveAsset = ({ rawVal, page }: PropsWithCMSProps<ReferenceProps>) => {
  const content = rawVal?.$ref ? (page?.getContent(rawVal) as any) : undefined;
  const url = page?.getUrl(content?.data?.asset?.links?.site) || '';
  return url
    ? {
        url,
      }
    : undefined;
};

export default resolveAsset;
